import { useDeviceType } from '../../../../../responsive/hooks';
export function useGetIsMobileDevice() {
  var deviceType = useDeviceType();
  return deviceType === 'phone';
}